<template>
  <a-modal width="800px" v-model="visible" :title="$t('experiment.exercise.details.title')" @cancel="handleCancel" :footer="null">
    <a-table class="details" :columns="columns" :data-source="data" bordered size="middle">
      <template slot="complete">
        <img src="@/assets/icons/icon_d@2x.png" style="width: 20px; height: 20px" alt="">
      </template>
      <template slot="timeUsed" slot-scope="text">
        {{ text }}s
      </template>
      <template slot="score" slot-scope="text">
        {{ text }}{{ $t('experiment.exercise.details.scoreUnit') }}
      </template>
    </a-table>
  </a-modal>
</template>

<script>
export default {
  name: 'PtDetails',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      columns: [
        {
          title: this.$t('experiment.exercise.details.step'),
          children: [
            {
              title: this.$t('experiment.exercise.details.detailedStep'),
              dataIndex: 'title',
              key: 'title'
            }
          ]
        },
        {
          title: this.$t('experiment.exercise.details.practice'),
          children: [
            {
              title: this.$t('experiment.exercise.details.isCompleted'),
              dataIndex: 'complete',
              key: 'complete',
              width: 150,
              scopedSlots: { customRender: 'complete' }
            },
            {
              title: this.$t('experiment.exercise.details.timeUsed'),
              dataIndex: 'timeUsed',
              key: 'timeUsed',
              width: 150,
              scopedSlots: { customRender: 'timeUsed' }
            },
            {
              title: this.$t('experiment.exercise.details.score'),
              dataIndex: 'score',
              key: 'score',
              width: 150,
              scopedSlots: { customRender: 'score' }
            }
          ]
        }
      ]
    }
  },

  mounted() {},

  methods: {
    handleCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
 /deep/ .details {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
  .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding: 6px 6px !important;
  }
  .ant-table-tbody > tr > td:nth-child(1) {
    font-weight: bold;
  }
  .ant-table-thead {
    tr:nth-child(1) > th {
      border: none;
      background: #EDF2F6;
      font-weight: bold;
    }
    tr:nth-child(2) > th {
      color: #6B738C;
      border: none;
      background: #F6F9FB;
      border-bottom: 1px solid #e8e8e8;
    }
    tr:nth-child(1) > th:nth-child(2) {
      border-right: 1px solid #e8e8e8;
    }
    tr:nth-child(2) > th:nth-child(4) {
      border-right: 1px solid #e8e8e8;
    }
  }
}
</style>
